<template>
  <div>
    <img
      src="../assets/logo.png"
      class="logo"
      alt="ICMSS 2021"
    >
    
    <div class="text-wrapper">
      <h1 class="title after-logo is-size-2-mobile">
        Welcome
      </h1>
      <h2 class="subtitle after-logo is-size-3-mobile">
        Ready to find out which shade of blue are you?
      </h2>
    </div>

    <next-button
      class="after-logo"
      @click.native="nextStep"
    />
  </div>
</template>

<script>
import NextButton from "./NextButton.vue";

export default {
  name: "Splash",
  components: {
    NextButton
  },
  methods: {
    nextStep() {
      this.$emit("next-step");
    }
  }
};
</script>


<style scoped>
.grid-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(4, 1fr);
  z-index: 10;
  animation: grid-fade-out 1s ease-in 3s forwards;
}

.grid-cell {
  width: 100%;
  height: 100%;
  transition: background-color 0.5s ease-in-out;
}

.text-wrapper {
  width: 55%;
}

.title.after-logo {
  text-align: left;
  margin-left: -10px;
}

.subtitle.after-logo {
  margin-top: 1rem;
}

@keyframes grid-fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    pointer-events: none;
  }
}

.after-logo {
  animation: after-logo-fade-in 1s linear 5s forwards;
  opacity: 0;
  z-index: 100;
}

@keyframes after-logo-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.logo {
  animation: logo-fade-in 1.5s ease-in-out 1.5s forwards,
    move-logo 1s ease-in-out 4s forwards;
  position: absolute;
  width: auto;
  max-height: 100vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  z-index: 20;
}

@keyframes logo-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes move-logo {
  from {
    max-height: 30vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  to {
    max-height: 15vh;
    top: 100px;
    left: 80%;
    transform: translate(-50%, 0);
  }
}

@keyframes move-logo-mobile {
  from {
    max-height: 25vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  to {
    max-height: 10vh;
    top: 35px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

@media screen and (max-width: 991px) {
  .text-wrapper {
    width: 100%;
  }

  .after-logo {
    z-index: 100;
  }

  .logo {
    animation: logo-fade-in 1.5s ease-in-out 1.5s forwards,
      move-logo-mobile 1s ease-in-out 4s forwards;
  }

  .grid-container {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(6, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .after-logo {
    z-index: 100;
  }
}

@media screen and (max-width: 480px) {
  .after-logo {
    z-index: 100;
  }
}

@media screen and (max-height: 500px) and (orientation: landscape) {
  .after-logo {
    z-index: 100;
  }
}
</style>
